import { useMemo } from "react";
import { CheckBox } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";
import Enums from "../../types/enums";

export const SettingsAccessTable = ({ rolePermissionsData, isEditing, id }) => {
  const { t } = useTranslation(["RolePermissions"]);
  var rolePermissions = rolePermissionsData?.RolePermissions;

  const handleCanAccessSettingsCheckboxChange = (args, id) => {
    let permissionToChange = rolePermissions.find((item) => item.Id === id);
    permissionToChange.CanAccessSettings = args.checked;
  };

  const permissions = useMemo(
    () => ({
      admin: rolePermissions?.filter(
        (x) => x.Role === Enums.AppRole.Administrator
      ),
      manager: rolePermissions?.filter((x) => x.Role === Enums.AppRole.Manager),
      staff: rolePermissions?.filter((x) => x.Role === Enums.AppRole.Staff),
      dataEntry: rolePermissions?.filter(
        (x) => x.Role === Enums.AppRole.DataEntry
      ),
    }),
    [rolePermissions]
  );

  const CanAccessSettingsTemplate = ({ rolePermission, id }) => {
    const isAdmin = rolePermission?.Role === Enums.AppRole.Administrator;

    return (
      <td className="permission-content">
        {isEditing ? (
          <CheckBox
            id={id}
            disabled={isAdmin}
            checked={rolePermission?.CanAccessSettings}
            change={(args) =>
              handleCanAccessSettingsCheckboxChange(args, rolePermission.Id)
            }
          />
        ) : (
          <i
            className={`${
              rolePermission?.CanAccessSettings
                ? "fa-solid fa-check"
                : "fa-solid fa-x"
            } icon`}
          ></i>
        )}
      </td>
    );
  };

  return (
    <div className="d-flex justify-content-between m-4" id={id}>
      <div className="col-3">
        <span className="user-permission-title">
          {t("SettingsAccessTable.Title")}
        </span>
      </div>
      <table className="user-permissions-table bc-bg-light-gray br-4">
        <thead>
          <tr className="border-bottom bg-et-lightest-gray">
            <th></th>
            <th>{t("Admin")}</th>
            <th>{t("Managers")}</th>
            <th>{t("Staff")}</th>
            <th>{t("DataEntry")}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div className="permission-description">
                <span className="span-block title">
                  {t("SettingsAccessTable.Row1Msg1")}
                </span>
                <span className="span-block description">
                  {t("SettingsAccessTable.Row1Msg2")}
                </span>
              </div>
            </td>

            <CanAccessSettingsTemplate
              id={id + "_can-access-settings_admin-checkbox"}
              rolePermission={permissions?.admin?.[0]}
            />
            <CanAccessSettingsTemplate
              id={id + "_can-access-settings_manager-checkbox"}
              rolePermission={permissions?.manager?.[0]}
            />
            <CanAccessSettingsTemplate
              id={id + "_can-access-settings_staff-checkbox"}
              rolePermission={permissions?.staff?.[0]}
            />
            <CanAccessSettingsTemplate
              id={id + "_can-access-settings_data-entry-checkbox"}
              rolePermission={permissions?.dataEntry?.[0]}
            />
          </tr>
        </tbody>
      </table>
    </div>
  );
};
